<template>
  <div>
    <v-layout wrap pl-2 ml-2>

      <v-flex v-if="checklists.length > 0" md12>
        <v-flex>
          <v-divider></v-divider>
        </v-flex>

        <v-flex mt-2 pt-2>
          <h3 v-if="casesId > 0 && this.vendorName">Vendor "{{ vendorName }}" Products</h3>
          <h3 v-else>Default checklist for the item</h3>
        </v-flex>

        <v-flex mt-2 pt-2>
          <v-flex v-for="(checklist, i) in checklists" :key="i">
            <v-flex v-if="checklist.editable">
              <v-text-field
                v-model="checklist.name"
                append-icon="save"
                :append-icon-cb="() => { saveCheckList(checklist) }"
              ></v-text-field>
            </v-flex>
            <v-checkbox
              v-else
              :id="i.toString()"
              :key="i"
              :label="checklist.service.name + ' - ' + '$' + checklist.service.price + ' - ' + checklist.service.category.name"
              v-model="checklist.model"
              @change="toggleCheckListStatus(checklist)"
              :prepend-icon="showRemoveButton"
              :prepend-icon-cb="() => { deleteCheckList(checklist) }"
            ></v-checkbox>
          </v-flex>
        </v-flex>
      </v-flex>
      <v-flex v-else>
        <span v-if="!loading.items">No items yet</span>
        <v-progress-circular
          v-if="loading.items"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-flex>

      <v-flex v-if="canAddToChecklist">

        <v-flex md12>
          <v-flex md8>
            <v-select
              :items="productsList"
              v-model="selectedProducts"
              label="Manage products in checklist"
              item-text="name"
              item-value="id"
              multiple
            ></v-select>
          </v-flex>

          <v-flex md12>
            <v-flex mt-5>
              <v-data-table
                v-if="selectedProductsAsObjects.length > 0"
                :items="selectedProductsAsObjects"
                :headers="productsTableHeaders"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.name }}</td>
                  <td class="quantity_bgcolor">
                    <v-edit-dialog
                      :return-value.sync="props.item.amount"
                      large
                      lazy
                      persistent
                    >
                      <div>{{ props.item.amount }}</div>
                      <template v-slot:input>
                        <div class="mt-3 title">Update Amount</div>
                      </template>
                      <template v-slot:input>
                        <v-text-field
                          v-model="props.item.amount"
                          label="Quantity"
                          single-line
                          autofocus
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td>${{ props.item.price }}</td>
                  <td>${{ props.item.amount * props.item.price }}</td>
                  <td>
                    <v-btn icon class="mx-0" @click="deleteElementWrapper(props.item.id)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex mt-5>
              <v-btn color="primary" block v-if="selectedProductsAsObjects.length > 0 && visible.attachServicesToCaseBtn" :loading="loading.attachServicesToCaseBtn" @click="attachServicesToCase">Attach products to case</v-btn>
            </v-flex>

          </v-flex>
        </v-flex>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
  import inventoriesAPI from '@/api/resources/inventories'
  import servicesAPI from '@/api/resources/services'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import resourcesMixins from '@/mixins/Resources'
  import checklistsAPI from '@/api/resources/checklists'
  import casesAPI from '@/api/resources/cases'
  import usersAPI from '@/api/user'

  export default {
    // TODO along with SelectPlanAndVendors move part of the products datatable management to stand alone component
    mixins: [ itemTypesMixins, resourcesMixins ],
    data () {
      return {
        productsTableHeaders: [
          { text: 'Name', value: 'name' },
          { text: 'Qty', value: 'amount', width: '5px' },
          { text: 'Unit', value: 'price' },
          { text: 'Subtotal', value: 'price' },
          { text: 'Actions', value: 'actions' }
        ],
        productsList: [],
        selectedProducts: [],
        checklists: [],
        vendorName: null,
        attachedServicesToCase: false,
        visible: {
          attachServicesToCaseBtn: true
        },
        loading: {
          items: false,
          attachServicesToCaseBtn: false
        },
        newQuestion: null
      }
    },
    computed: {
      resources () {
        return 'cases/' + this.casesId + '/service'
      },
      canAddToChecklist () {
        return this.$can('add', 'checklist-item') && this.productsList.length > 0
      },
      itemTypeAPI () {
        switch (this.itemType) {
          case this.inventoryTypeID: return inventoriesAPI
          case this.serviceTypeID: return servicesAPI
        }
      },
      showRemoveButton () {
        if (this.$can('delete', 'checklist-item')) {
          return 'close'
        }

        return ''
      },
      showEditButton () {
        if (this.$can('edit', 'checklist-item')) {
          return 'edit'
        }

        return ''
      },
      selectedProductsAsObjects () {
        return this.productsList.filter(filtering => {
          let inList = this.selectedProducts.includes(filtering.id)

          if (inList) {
            let found = this.checklists.find(finding => finding.item_id === filtering.id)

            if (found) {
              filtering.amount = found.quantity
            }
          }

          return inList
        })
      }
    },
    methods: {
      deleteElementSuccess () {
        this.loadProducts()
        this.loadCheckList()
      },
      deleteElementWrapper (itemId) {
        this.deleteElement(itemId)
      },
      loadProducts () {
        usersAPI.getLinkedProducts(this.itemId).then(result => {
          this.productsList = result
        }, () => {})
      },
      loadListingSuccess () {
        this.loadProducts()
      },
      attachServicesToCase () {
        let promise = casesAPI.attachVendorServicesToCase(this.casesId, this.selectedProductsAsObjects)

        promise.then(() => {
          this.loading.attachServicesToCaseBtn = true

          this.attachedServicesToCase = true
          this.loading.attachServicesToCaseBtn = false
          this.visible.attachServicesToCaseBtn = false

          this.$store.dispatch('loadAllCases')

          this.loadCheckList()
        })
      },
      toggleCheckListStatus (item) {
        checklistsAPI.setCheckListStatus(item.id, item.model).then(() => {}, () => {})
      },
      deleteCheckList (item) {
        checklistsAPI.delete(item.id).then(() => {
          let index = this.checklists.findIndex((checklist) => {
            return checklist.id === item.id
          })

          this.$store.dispatch('loadAllCases')

          this.checklists.splice(index, 1)
        }, () => {})
      },
      editCheckList (item) {
        item.editable = true
      },
      saveCheckList (item) {
        item.editable = false

        checklistsAPI.editQuestion(item.id, item.question).then(() => {}, () => {})
      },
      addCheckList () {
        checklistsAPI.add(this.selectedProducts, this.itemType, this.newQuestion, this.casesId).then(() => {
          this.loadCheckList()
        }, () => {})

        casesAPI.attachServicesToCase(this.casesId, this.selectedProductsAsObjects).then(() => {}, () => {})
      },
      loadCheckList () {
        this.loading.items = true

        let promise = null

        this.checklists = []

        if (this.casesId > 0) {
          promise = casesAPI.getVendorProducts(this.casesId, this.itemId)

          promise.then(result => {
            result.forEach(checklist => {
              checklist.model = checklist.is_complete
              checklist.editable = false
            })

            this.loading.items = false

            this.selectedProducts = result.map(mapping => mapping.item_id)
            this.checklists = result
          }, () => {
            this.loading.items = false
          })
        }
      }
    },
    watch: {
      itemId (newVal) {
        this.loadCheckList(newVal)
      },
      selectedProductsAsObjects: {
        handler () {
          this.visible.attachServicesToCaseBtn = true
          this.loading.attachServicesToCaseBtn = false
          this.attachedServicesToCase = false
        },
        deep: true
      }
    },
    created () {
      this.loadCheckList()

      usersAPI.loadUser(this.itemId).then(result => {
        this.vendorName = result.name
      }, () => {})

      this.loadProducts()
    },
    props: {
      casesId: {
        type: Number,
        required: false
      },
      itemId: {
        type: Number,
        required: true
      },
      itemType: {
        type: Number,
        required: true
      }
    }
  }
</script>

<style scoped>
  .quantity_bgcolor {
    background-color: #8c9eff;
  }
</style>



// WEBPACK FOOTER //
// ItemCheckList.vue?6e0b7c74